import React from 'react'

const StatBadge = ({ label, isActive, onClick }) => {
  return (
    <button
    onClick={onClick}
    className={`px-4 py-2  rounded-md transition-all border border-[#E0E2E7] ${isActive ? 'bg-[#00811D1A]/10 text-[#000000]' : 'bg-[#FFFFFF] text-[#0F172ACC]/80'}`}
>
    {label}
</button>
  )
}

export default StatBadge